import React from 'react'

const SocketClientContext = React.createContext();

export default SocketClientContext;
